<script setup lang="ts">
  import { computed, defineAsyncComponent } from 'vue'
  import { useFeaturesStore } from '@/shared/store/featuresStore'

  const FlowTravelDatesWidgetQC = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowTravelDatesWidgetQC/FlowTravelDatesWidgetQC.vue')
  )
  const FlowTravelDatesWidget = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowTravelDatesWidget/FlowTravelDatesWidget.vue')
  )
  import { useApiRequestsAbort } from '@/shared/composables'

  const featuresStore = useFeaturesStore()
  const isDatesQcEnabled = computed(() => featuresStore.isDatesQcEnabled)
  useApiRequestsAbort()
</script>

<template>
  <FlowTravelDatesWidgetQC v-if="isDatesQcEnabled" />
  <FlowTravelDatesWidget v-else />
</template>
